import visually from './visually';
import click from './click';
import clickOutside from './click-outside';
import inputAutoFocus from './input-auto-focus';

// 自定义指令
const directives = {
    visually,
    click,
    clickOutside,
    focus: inputAutoFocus
};

export default {
    install(Vue) {
        Object.keys(directives).forEach(key => {
            Vue.directive(key, directives[key]);
        });
    }
};